/* eslint-disable */

export const onboardingSlides = {
  'data': [{
    'amp_url': null,
    'api_url': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries\/09854e1d-1151-4a24-a64a-3ddcc856dfa3',
    'button_text': 'next',
    'collection': {'id': 'onboarding', 'title': 'Onboarding', 'api_url': null},
    'content': '',
    'date': '2020-08-27T19:57:20.000000Z',
    'description': '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.<\/p>',
    'edit_url': 'http:\/\/hotel-api.test\/cp\/collections\/onboarding\/entries\/09854e1d-1151-4a24-a64a-3ddcc856dfa3\/welcome-to-the-unbound',
    'id': '09854e1d-1151-4a24-a64a-3ddcc856dfa3',
    'image': {
      'id': 'images::onboarding\/onboarding-step-1@2x.jpg',
      'url': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-1@2x.jpg',
      'permalink': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-1@2x.jpg',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/assets\/images\/onboarding\/onboarding-step-1@2x.jpg'
    },
    'is_entry': true,
    'label': 'nature within amsterdam',
    'last_modified': '2020-08-27T19:57:20.000000Z',
    'parent': null,
    'permalink': 'http:\/\/hotel-api.test',
    'private': false,
    'published': true,
    'slug': 'welcome-to-the-unbound',
    'title': 'Welcome to the unbound',
    'updated_at': '2020-08-27T19:57:20.000000Z',
    'updated_by': {
      'id': 1,
      'name': 'Chimp',
      'email': 'info@chimp.nl',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/users\/1'
    },
    'uri': null,
    'url': '\/'
  }, {
    'amp_url': null,
    'api_url': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries\/89c84092-9cc8-4ec7-9edb-6a7997483a45',
    'button_text': 'next',
    'collection': {'id': 'onboarding', 'title': 'Onboarding', 'api_url': null},
    'content': '',
    'date': '2020-08-27T19:58:12.000000Z',
    'description': '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.<\/p>',
    'edit_url': 'http:\/\/hotel-api.test\/cp\/collections\/onboarding\/entries\/89c84092-9cc8-4ec7-9edb-6a7997483a45\/lorem-ipsum-dolor',
    'id': '89c84092-9cc8-4ec7-9edb-6a7997483a45',
    'image': {
      'id': 'images::onboarding\/onboarding-step-2@2x.jpg',
      'url': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-2@2x.jpg',
      'permalink': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-2@2x.jpg',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/assets\/images\/onboarding\/onboarding-step-2@2x.jpg'
    },
    'is_entry': true,
    'label': 'adipisicing elit',
    'last_modified': '2020-08-27T19:58:12.000000Z',
    'parent': null,
    'permalink': 'http:\/\/hotel-api.test',
    'private': false,
    'published': true,
    'slug': 'lorem-ipsum-dolor',
    'title': 'Lorem ipsum dolor',
    'updated_at': '2020-08-27T19:58:12.000000Z',
    'updated_by': {
      'id': 1,
      'name': 'Chimp',
      'email': 'info@chimp.nl',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/users\/1'
    },
    'uri': null,
    'url': '\/'
  }, {
    'amp_url': null,
    'api_url': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries\/77f75794-5951-4dd9-9e11-df22aeaa78e3',
    'button_text': 'Let\'s go',
    'collection': {'id': 'onboarding', 'title': 'Onboarding', 'api_url': null},
    'content': '',
    'date': '2020-08-27T19:59:07.000000Z',
    'description': '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.<\/p>',
    'edit_url': 'http:\/\/hotel-api.test\/cp\/collections\/onboarding\/entries\/77f75794-5951-4dd9-9e11-df22aeaa78e3\/ready-to-make-memories',
    'id': '77f75794-5951-4dd9-9e11-df22aeaa78e3',
    'image': {
      'id': 'images::onboarding\/onboarding-step-3@2x.jpg',
      'url': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-3@2x.jpg',
      'permalink': 'http:\/\/hotel-api.test\/storage\/onboarding\/onboarding-step-3@2x.jpg',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/assets\/images\/onboarding\/onboarding-step-3@2x.jpg'
    },
    'is_entry': true,
    'label': 'Lorem ipsum dolor',
    'last_modified': '2020-08-27T19:59:07.000000Z',
    'parent': null,
    'permalink': 'http:\/\/hotel-api.test',
    'private': false,
    'published': true,
    'slug': 'ready-to-make-memories',
    'title': 'Ready to make memories',
    'updated_at': '2020-08-27T19:59:07.000000Z',
    'updated_by': {
      'id': 1,
      'name': 'Chimp',
      'email': 'info@chimp.nl',
      'api_url': 'http:\/\/hotel-api.test\/content-api\/users\/1'
    },
    'uri': null,
    'url': '\/'
  }],
  'links': {
    'first': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries?page=1',
    'last': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries?page=1',
    'prev': null,
    'next': null
  },
  'meta': {
    'current_page': 1,
    'from': 1,
    'last_page': 1,
    'path': 'http:\/\/hotel-api.test\/content-api\/collections\/onboarding\/entries',
    'per_page': 25,
    'to': 3,
    'total': 3
  }
}
